export default "__VITE_ASSET__CPiBrLkA__"